import {container} from "tsyringe";
import {ICommandHandler} from "../commands/handlers/i-command.handler";
import {ICommand} from "../commands/i-command.interface";
import {CommandBus} from "../services/command-bus.service";
import {EventBus} from "../services/event-bus.service";
import {ClassOf} from "../types/class-of.type";

export function CommandHandler<T>(_prototype: ClassOf<ICommand<T>>) {

    return function (commandHandlerPrototype: ClassOf<ICommandHandler<any>>) {
        container.resolve(CommandBus).registerCommandHandler(_prototype, commandHandlerPrototype);
        commandHandlerPrototype.prototype._eventBus = container.resolve(EventBus);
    }
}